import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgIdleModule } from '@ng-idle/core';
import { BaseComponent } from './components/base.component';
import { ToastContainerComponent } from './components/toast-container/toast-container.component';
import { DirectivesModule } from './directives/directives.module';
import { HttpInterceptorClass } from './interceptors/http.interceptor';
import { LoaderInterceptor } from './interceptors/loader.interceptor';
import { HeaderModule } from './modules/header/header.module';
import { LeftNavigationModule } from './modules/left-navigation/left-navigation.module';
import { PipesModule } from './pipes/pipes.module';
import { AppRoutingModule } from './routing/app-routing.module';
import { AppInitService } from './services/app-init-service';
import { ApplicantMobileChangeService } from './services/applicant-mobile-change.service';
import { AuthService } from './services/auth-service';
import { BaseService } from './services/base.service';
import { BroadcastService } from './services/broadcaster.service';
import { ClientDetailService } from './services/client-detail-service';
import { EncryptDecryptService } from './services/encrypt-decrypt.service';
import { GlobalErrorHandler } from './services/error.handler.service';
import { HttpService } from './services/http.service';
import { LoaderService } from './services/loader.service';
import { LocalStorageService } from './services/local-storage.service';
import { MessageService } from './services/message.service';
import { PermissionService } from './services/permission.service';
import { QBTokenChangeService } from './services/qb_token_change-service';
import { ThemeService } from './services/theme.service';
import { UserService } from './services/user.service';

export function initializeApp(appInitService: AppInitService) {
  return (): Promise<boolean> => {
    return appInitService.init();
  }
}

@NgModule({
    imports: [
      CommonModule,
      HeaderModule,
      LeftNavigationModule,
      PipesModule,
      AppRoutingModule,
      HttpClientModule,
      FormsModule,
      ReactiveFormsModule,
      BrowserAnimationsModule,
      NgbModule,
      NgIdleModule.forRoot(),
      DirectivesModule
    ],
    declarations: [
      BaseComponent,
      ToastContainerComponent,
    ],
    providers: [
      BaseService,
      BroadcastService,
      GlobalErrorHandler,
      HttpService,
      LoaderService,
      AuthService,
      LocalStorageService,
      EncryptDecryptService,
      MessageService,
      UserService,
      ClientDetailService,
      PermissionService,
      ApplicantMobileChangeService,
      ThemeService,
      QBTokenChangeService,
      { provide: APP_INITIALIZER,useFactory: initializeApp, deps: [AppInitService], multi: true},
      { provide: HTTP_INTERCEPTORS, useClass: HttpInterceptorClass, multi: true },
      { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor,multi: true}

    ],

    exports:[
      HeaderModule,
      LeftNavigationModule,
      PipesModule,
      AppRoutingModule,
      BaseComponent,
      ToastContainerComponent,
      FormsModule,
      ReactiveFormsModule,
      NgbModule,
      DirectivesModule
    ]
})
export class CoreModule {
}

export * from './services/base.service';
export * from './services/broadcaster.service';
export * from './services/encrypt-decrypt.service';
export * from './services/error.handler.service';
export * from './services/http.service';
export * from './services/loader.service';
export * from './services/local-storage.service';
export * from './services/message.service';
export * from './services/permission.service';
export * from './services/theme.service';
export * from './services/user.service';

